import {createApp} from 'vue'
import App from './App.vue'

const htmlElement = document.querySelector("#roiapp")
const lang = htmlElement.dataset.lang
const annualPositions = htmlElement.dataset.annualpositions
const applicantsPerPosition = htmlElement.dataset.applicantsperposition
const timeSpentPerApplicant = htmlElement.dataset.timespentperapplicant
const recruitersHourlySalary = htmlElement.dataset.recruitershourlysalary
const recruitersPerPosition = htmlElement.dataset.recruitersperposition
const timeSaved = htmlElement.dataset.timesaved
const moneySaved = htmlElement.dataset.moneysaved

const app = createApp(App, {
                labelLang: lang,
                labelAnnualPositions: annualPositions,
                labelApplicantsPerPosition: applicantsPerPosition,
                labelTimeSpentPerApplicant: timeSpentPerApplicant,
                labelRecruitersHourlySalary: recruitersHourlySalary,
                labelRecruitersPerPosition: recruitersPerPosition,
                labelTimeSaved: timeSaved,
                labelMoneySaved: moneySaved
  })
  
  app.mount('#roiapp')